<template>
  <b-container id="home-content">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true" />
    <section class="apresentacao">
      <!-- <img class="apresentacao__img" src="@/components/img/IMG_5640.JPG" /> -->
      <b-img src="https://cdn-griffo.nyc3.cdn.digitaloceanspaces.com/SRN/g256.png" class="logoGriffo" fluid alt="Responsive image"></b-img>
    </section>
    <section class="login__form">
      <HomeFormulario @loginMethod="login" />
    </section>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex'
import bContainer from 'bootstrap-vue/es/components/layout/container'
import HomeFormulario from './HomeFormulario.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'Home',
  components: {
    bContainer,
    HomeFormulario,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('autenticacao', [
      'realizaLoginStore',
    ]),
    async login(dadosUsuario) {
      this.mostrarLoading()
      try {
        await this.realizaLoginStore(dadosUsuario)
        this.$router.push({ name: 'rota-dashboard' })
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoading(false)
      }
    },
    mostrarLoading(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/breakpoints.scss';

#home-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  @media (min-width: $medium-size) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}

.apresentacao {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;

  @media (min-width: $medium-size) {
    justify-content: flex-start;
  }

  &__img {
    width: 16rem;
    @media (min-width: $extra-small-size) {
      width: 24rem;
    }
  }
}

.login__form {
  margin: 1rem 0;
  height: 100%;
  width: auto;

  @media (min-width: $medium-size) {
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

}

</style>
